module.exports = __webpack_public_path__ + "static/img/1692694658693.cbee3ee4.jpg";